import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Typography,
  IconButton,
  Slide,
} from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";
import { makeStyles } from "@material-ui/core/styles";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const useStyles = makeStyles((theme) => ({
  paper: {
    borderRadius: 12,
    overflow: "hidden",
    boxShadow: "0 24px 64px rgba(0,0,0,0.14), 0 8px 24px rgba(0,0,0,0.08)",
  },
  titleRoot: {
    margin: 0,
    padding: theme.spacing(3, 3, 2.5, 3),
    borderBottom: "2px solid",
    borderBottomColor: theme.palette.primary.main,
    background: `linear-gradient(135deg, #fff 0%, #fafafa 100%)`,
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
  },
  title: {
    fontWeight: 600,
    fontSize: "1.15rem",
    letterSpacing: "-0.01em",
    color: theme.palette.text.primary,
    lineHeight: 1.3,
    [theme.breakpoints.down("xs")]: {
      maxWidth: "14rem",
      overflow: "hidden",
      textOverflow: "ellipsis",
      whiteSpace: "nowrap",
    },
  },
  closeButton: {
    padding: theme.spacing(0.75),
    color: theme.palette.grey[500],
    borderRadius: 8,
    transition: "background 0.18s ease, color 0.18s ease, transform 0.18s ease",
    "&:hover": {
      background: "rgba(233, 58, 36, 0.08)",
      color: theme.palette.primary.main,
      transform: "rotate(90deg)",
    },
  },
  content: {
    padding: theme.spacing(3),
    "&:first-child": {
      paddingTop: theme.spacing(3),
    },
  },
}));

const Modal = ({
  title,
  onClose,
  open,
  children,
  fullScreen = false,
  fullWidth = false,
  maxWidth = "sm",
}) => {
  const classes = useStyles();

  return (
    <Dialog
      fullScreen={fullScreen}
      fullWidth={fullWidth}
      maxWidth={maxWidth}
      open={open}
      onClose={onClose}
      TransitionComponent={Transition}
      PaperProps={{ className: classes.paper }}
    >
      <DialogTitle className={classes.titleRoot} disableTypography>
        <Typography className={classes.title}>{title}</Typography>
        <IconButton onClick={onClose} className={classes.closeButton} size="small">
          <CloseIcon fontSize="small" />
        </IconButton>
      </DialogTitle>
      <DialogContent className={classes.content}>{children}</DialogContent>
    </Dialog>
  );
};

export default Modal;
